export { DownloadGraphics } from './DownloadGraphics.component';
